import React, { useState } from "react";

interface ButtonProps {
  title: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isRevert?: boolean;
}

const StyledButton: React.FunctionComponent<ButtonProps> = ({ title, onClick, isRevert = false }) => {
  const [isHovered, setIsHovered] = useState(isRevert);

  const buttonStyle: React.CSSProperties = {
    textTransform: "uppercase",
    border: "none",
    fontFamily: "Avenir Next Codensed Regular",
    fontSize: 15,
    fontWeight: 300,
    letterSpacing: ".25em",
    minHeight: 50,
    maxHeight: 60,
    padding: "20px 30px",
    marginTop: 40,
    lineHeight: "18px",
    transition: "all 0.3s ease",
    background: isHovered ? "#c39d63" : "rgba(255, 255, 255, 0.9)",
    color: isHovered ? "rgba(255, 255, 255, 0.9)" : "#c39d63",
    cursor: "pointer",
  };

  return (
    <button
      onClick={onClick}
      style={buttonStyle}
      onMouseEnter={() => setIsHovered(!isHovered)}
      onMouseLeave={() => setIsHovered(!isHovered)}
    >
      <BeforeComponent isHovered={isHovered} />
      {title}
    </button>
  );
};

export default StyledButton;

interface BeforeComponentProps {
  isHovered: boolean;
}

const BeforeComponent: React.FC<BeforeComponentProps> = ({ isHovered }) => {
  const bgBefore: React.CSSProperties = {
    content: "''",
    width: "20px",
    height: "1px",
    background: isHovered ? "rgba(255, 255, 255, 0.9)" : "#c39d63",
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: "10px",
    transition: "all 0.3s ease",
  };
  return <div style={bgBefore}></div>;
};